import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const SignupForm = () => {
  const [formData, setFormData] = useState({
    email: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      email: formData.email,
    };

    emailjs.send('service_gvt5vwp', 'template_nwga3kh', templateParams, 'OpJMLUp7AgSF4zW4L')
      .then((response) => {
        alert('Form submitted successfully!');
        setFormData({
          email: '',
        });
      }, (error) => {
        alert('There was an error submitting the form.');
        console.error('Failed to send email:', error);
      });
  };

  return (
    <form className="signup-form" onSubmit={handleSubmit}>
      <input
        type="email"
        name="email"
        placeholder="Email Address"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <button type="submit">Sign Up</button>
    </form>
  );
};

export default SignupForm;
